import { AddonService } from 'types/AddonService';
import { Option } from 'types/Generics';
import { Pet } from 'types/Pet';
import { Service } from 'types/Service';

export enum OnlineBookingStep {
    Home,
    NewClientForm,
    Signin,
    AddPet,
    SelectPets,
    SelectServices,
    SelectStaff,
    SelectDateTime,
    NotesAndAgreements,
    Payment,
    Success
}

export interface OnlineBookingPreferences {
    enabled: boolean;
    bookingDateLimits: {
        from: string | null;
        to: string | null;
    };
    allowNewClients: boolean;
    allowSelectStaff: boolean;
    requireBookingRequest: boolean;
    promoImageUrl: string;
    pricingOption: OnlineBookingPricingOption;
}

export type TimeLimit = Option<string> & {
    offsetSeconds: number;
};

export const OnlineBookingPricingOptions = {
    StartingAt: 'starting_at',
    Price: 'price'
} as const;

export type OnlineBookingPricingOption =
    (typeof OnlineBookingPricingOptions)[keyof typeof OnlineBookingPricingOptions];

export interface OnlineBookingTime {
    hour: number;
    minute: number;
    label: string;
    staffId: number;
}

export interface OnlineBookingItem {
    pet: Pet;
    service?: Service;
    addons: Array<AddonService>;
}
